import apiInstance from '../libs/axios'

export const fetchPublisher = (query) => apiInstance.get(`/api/publisher${query ? `?${query}` : ''}`)

export const createPublisher = (data) => apiInstance.post('/api/publisher', data)

export const updatePublisher = (data) => apiInstance.patch(`/api/publisher/${data.id}`, data)
